import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import PageStructure from 'flarum/forum/components/PageStructure';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
const label = {
  ban: 'Ban',
  mute: 'Voice mute',
  gag: 'Chat gag',
  kick: 'Kick',
  team_ban: 'Team ban'
};
const date = value => value ? new Date(value).toLocaleString() : 'Permanent';
export default class PunishmentsPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    this.query = '';
    this.status = 'all';
    this.kind = '';
    this.page = 1;
    this.rows = [];
    this.total = 0;
    this.viewer = {};
    this.loading = true;
    this.busy = false;
    this.error = '';
    this.message = '';
    this.removing = null;
    this.removalReason = '';
    this.form = {
      target_identity_type: 'steam64',
      target_identity_value: '',
      player_name: '',
      game_type: 'source2',
      punishment_type: 'ban',
      duration_seconds: 3600,
      reason: ''
    };
    this.load();
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    app.setTitle('Punishments');
  }
  url() {
    return `${app.forum.attribute('apiUrl')}/hideout/bans/punishments`;
  }
  errorText(error) {
    return error?.response?.error || 'The request could not be completed. Please try again.';
  }
  async load() {
    this.loading = true;
    this.error = '';
    try {
      const query = new URLSearchParams({
        q: this.query,
        status: this.status,
        punishment_type: this.kind,
        page: this.page
      });
      const result = await app.request({
        method: 'GET',
        url: `${this.url()}?${query}`
      });
      this.rows = result.data;
      this.total = result.total;
      this.viewer = result.viewer;
      if (this.viewer.game_types?.length && !this.viewer.game_types.includes(this.form.game_type)) {
        this.form.game_type = this.viewer.game_types[0];
      }
    } catch (error) {
      this.error = this.errorText(error);
    } finally {
      this.loading = false;
      m.redraw();
    }
  }
  async submit(event) {
    event.preventDefault();
    if (this.busy) return;
    this.busy = true;
    this.error = '';
    this.message = '';
    try {
      await app.request({
        method: 'POST',
        url: this.url(),
        body: {
          ...this.form
        }
      });
      this.message = 'Punishment saved. Connected game servers will apply the update.';
      this.form.reason = '';
      this.page = 1;
      await this.load();
    } catch (error) {
      this.error = this.errorText(error);
    } finally {
      this.busy = false;
      m.redraw();
    }
  }
  async remove(event) {
    event.preventDefault();
    if (this.busy || !this.removing) return;
    this.busy = true;
    this.error = '';
    this.message = '';
    try {
      await app.request({
        method: 'POST',
        url: `${this.url()}/${this.removing.id}/remove`,
        body: {
          reason: this.removalReason
        }
      });
      this.removing = null;
      this.removalReason = '';
      this.message = 'Punishment removed. Its history has been retained.';
      await this.load();
    } catch (error) {
      this.error = this.errorText(error);
    } finally {
      this.busy = false;
      m.redraw();
    }
  }
  view() {
    return m(PageStructure, {
      className: "HideoutBansPage"
    }, m("div", {
      className: "container HideoutBans"
    }, m("header", {
      className: "HideoutBans-header"
    }, m("span", {
      className: "HideoutBans-eyebrow"
    }, "THE HIDEOUT"), m("h1", null, "Punishments"), m("p", null, "Search player history, active restrictions and past decisions.")), false && m("div", {
      className: "Alert Alert--error",
      role: "alert"
    }, this.error), this.message && m("div", {
      className: "Alert Alert--success",
      role: "status"
    }, this.message), this.viewer.can_moderate && m("details", {
      className: "HideoutBans-card"
    }, m("summary", null, "Issue a punishment"), m("form", {
      onsubmit: event => this.submit(event),
      className: "HideoutBans-form"
    }, m("label", null, "SteamID64", m("input", {
      className: "FormControl",
      required: true,
      pattern: "7656119[0-9]{10}",
      maxLength: "17",
      inputmode: "numeric",
      value: this.form.target_identity_value,
      oninput: e => this.form.target_identity_value = e.target.value.trim()
    })), m("label", null, "Player name", m("input", {
      className: "FormControl",
      maxLength: "100",
      value: this.form.player_name,
      oninput: e => this.form.player_name = e.target.value
    })), m("label", null, "Restriction", m("select", {
      className: "FormControl",
      value: this.form.punishment_type,
      onchange: e => this.form.punishment_type = e.target.value
    }, ['ban', 'mute', 'gag'].map(kind => m("option", {
      value: kind
    }, label[kind])))), m("label", null, "Duration", m("select", {
      className: "FormControl",
      value: this.form.duration_seconds,
      onchange: e => this.form.duration_seconds = Number(e.target.value)
    }, [[900, '15 minutes'], [3600, '1 hour'], [86400, '1 day'], [604800, '1 week'], [2592000, '30 days'], [0, 'Permanent']].map(_ref => {
      let [v, l] = _ref;
      return m("option", {
        value: v
      }, l);
    }))), m("label", null, "Game", m("select", {
      className: "FormControl",
      value: this.form.game_type,
      onchange: e => this.form.game_type = e.target.value
    }, (this.viewer.game_types || []).map(game => m("option", {
      value: game
    }, game)))), m("label", {
      className: "HideoutBans-wide"
    }, "Reason", m("input", {
      className: "FormControl",
      required: true,
      maxLength: "500",
      value: this.form.reason,
      oninput: e => this.form.reason = e.target.value
    })), m(Button, {
      className: "Button Button--primary",
      type: "submit",
      loading: this.busy,
      disabled: this.busy
    }, "Save punishment"))), this.removing && m("form", {
      className: "HideoutBans-card",
      onsubmit: e => this.remove(e)
    }, m("h2", null, "Remove ", label[this.removing.punishment_type], " #", this.removing.id), m("p", null, this.removing.player.username, " \xB7 ", this.removing.player.identities[0].identity_value), m("label", null, "Removal reason", m("input", {
      className: "FormControl",
      required: true,
      maxLength: "500",
      value: this.removalReason,
      oninput: e => this.removalReason = e.target.value
    })), m("div", {
      className: "HideoutBans-actions"
    }, m(Button, {
      type: "submit",
      className: "Button Button--primary",
      loading: this.busy,
      disabled: this.busy
    }, "Confirm removal"), m(Button, {
      type: "button",
      className: "Button",
      disabled: this.busy,
      onclick: () => this.removing = null
    }, "Cancel"))), m("form", {
      className: "HideoutBans-filters",
      onsubmit: e => {
        e.preventDefault();
        this.page = 1;
        this.load();
      }
    }, m("label", null, "Player", m("input", {
      className: "FormControl",
      placeholder: "Name or SteamID64",
      maxLength: "100",
      value: this.query,
      oninput: e => this.query = e.target.value
    })), m("label", null, "Status", m("select", {
      className: "FormControl",
      value: this.status,
      onchange: e => this.status = e.target.value
    }, ['all', 'active', 'expired', 'removed'].map(value => m("option", {
      value: value
    }, value[0].toUpperCase() + value.slice(1))))), m("label", null, "Type", m("select", {
      className: "FormControl",
      value: this.kind,
      onchange: e => this.kind = e.target.value
    }, m("option", {
      value: ""
    }, "All types"), Object.entries(label).map(_ref2 => {
      let [key, value] = _ref2;
      return m("option", {
        value: key
      }, value);
    }))), m(Button, {
      type: "submit",
      className: "Button Button--primary",
      disabled: this.loading
    }, "Search")), this.loading ? m(LoadingIndicator, null) : m("div", null, m("p", {
      className: "HideoutBans-count"
    }, this.total, " record", this.total === 1 ? '' : 's'), !this.rows.length && m("div", {
      className: "HideoutBans-card"
    }, "No punishments match your search."), this.rows.map(row => m("article", {
      key: row.id,
      className: "HideoutBans-card"
    }, m("div", {
      className: "HideoutBans-row"
    }, m("h2", null, row.player.username || row.player.identities[0].identity_value), m("span", {
      className: `HideoutBans-status ${row.active ? 'is-active' : ''}`
    }, row.removed_at ? 'Removed' : row.active ? 'Active' : row.punishment_type === 'kick' ? 'Recorded' : 'Expired')), m("div", {
      className: "HideoutBans-meta"
    }, "#", row.id, " \xB7 ", label[row.punishment_type], " \xB7 ", row.game_type, " \xB7 ", m("span", null, row.player.identities[0].identity_value)), m("p", {
      className: "HideoutBans-reason"
    }, row.reason), m("dl", {
      className: "HideoutBans-details"
    }, m("div", null, m("dt", null, "Issued by"), m("dd", null, row.admin.username)), m("div", null, m("dt", null, "Issued"), m("dd", null, date(row.starts_at))), m("div", null, m("dt", null, "Expires"), m("dd", null, date(row.ends_at)))), row.removed_at && m("p", {
      className: "HideoutBans-meta"
    }, "Removed by ", row.removed_by, " on ", date(row.removed_at), " \xB7 ", row.removal_reason), row.active && this.viewer.can_moderate && m(Button, {
      className: "Button",
      disabled: this.busy,
      onclick: () => {
        this.removing = row;
        this.removalReason = '';
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    }, "Remove restriction"))), m("div", {
      className: "HideoutBans-actions"
    }, m(Button, {
      className: "Button",
      disabled: this.page <= 1,
      onclick: () => {
        this.page--;
        this.load();
      }
    }, "Previous"), m("span", null, "Page ", this.page, " of ", Math.max(1, Math.ceil(this.total / 25))), m(Button, {
      className: "Button",
      disabled: this.page * 25 >= this.total,
      onclick: () => {
        this.page++;
        this.load();
      }
    }, "Next")))));
  }
}
flarum.reg.add('thehideout-core', 'forum/components/PunishmentsPage', PunishmentsPage);